import { FormEvent } from "react";
import { toast } from "react-toastify";
import { useSendMailMessageMutation } from "../../store/apiSlices/messages";
import { PaperAirplaneIcon } from "../Icons";

export default function ChatInput({ contactId }: { contactId: string }) {
  const [sendMailMessage] = useSendMailMessageMutation();

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const message = formData.get("message") as string;

    if (!message.trim()) {
      toast.warning("Enter a valid message");
      return;
    }

    const payload = {
      vendor_contacts_id: contactId,
      message,
    };

    await sendMailMessage(payload);
    form.reset();
  };

  return (
    <footer className="p-3 border-t border-gray-200">
      <form onSubmit={handleSubmit} className="flex items-end gap-2">
        <textarea
          name="message"
          placeholder="Type a message…"
          required
          minLength={5}
          onInput={(e) => {
            e.currentTarget.style.height = "auto";
            e.currentTarget.style.height =
              Math.min(e.currentTarget.scrollHeight, 120) + "px";
          }}
          style={{ lineHeight: "1.4rem" }}
        ></textarea>

        <button
          type="submit"
          className="flex items-center justify-center p-2 rounded-xl bg-custom-blue-medium text-white hover:bg-blue-600 transition-colors"
        >
          <PaperAirplaneIcon />
        </button>
      </form>
    </footer>
  );
}
